<div class="fixed top-0 right-0 bg-opacity-60 dark:bg-opacity-50 w-screen h-screen z-[10000000000000000] bg-slate-500 dark:bg-darkMode-600 backdrop-blur-[5px] dark:backdrop-blur-1 flex items-center justify-center">
</div>
<div class="m-auto fixed loading-box w-full z-[10000000000000000] h-10 bg-transparent">
    <div class="lds-dual-ring"></div>
</div>